import { View } from "@pimo/pimo-app-builder";
import { titleCardEditSchema } from "@pimo/pimo-components";
import { DragAndDropLayout } from "@pimo/pimo-components/src/lib/layouts/drag-and-drop-layout/drag-and-drop-layout";
import {
  PMTitleCard,
  PMTitleCardProps,
} from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";
import { formatDate } from "../../../utils/format-date";

export function addTitleCard(
  view: View<TestAppState, DragAndDropLayout>
): void {
  const titleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "titleComponent",
      title: "",
      description: "",
      labels: ["title", "dashboardTitle"],
      editSchema: titleCardEditSchema,
    },
  });

  titleComponent.mapLayoutProps(({ language }) => ({
    componentId: "titleComponent",
    description: getLocalizedMessage(language || "en", "titleDescription"),
    title: getLocalizedMessage(language || "en", "dashboard"),
    labels: ["title", "dashboardTitle"],
    editSchema: titleCardEditSchema,
  }));

  titleComponent.mapState(
    ({ dashboardComponentValues, settings, language, dashboard }) => {
      return {
        title:
          (dashboardComponentValues?.["titleComponent"] as PMTitleCardProps)
            ?.title ??
          `${
            getLocalizedMessage(language || "en", "dashboard") || "Dashboard"
          } ${
            settings?.configuration?.programName
              ? `- ${settings?.configuration?.programName}`
              : ""
          }`,
        badgeConfigs: dashboard?._calculated.lastReportingEndDate
          ? [
              {
                label: `${
                  getLocalizedMessage(language || "en", "AsOf") || "As of"
                }: ${formatDate(dashboard?._calculated.lastReportingEndDate, language)}`,
                backgroundColor: theme.palette.secondary.light,
                color: theme.palette.primary.main,
              },
            ]
          : [],
      };
    }
  );
}
